import { dateSort } from "helpers/sort";

import { IEntityCollectionState } from "../reducer";

import { IEmailTemplate } from "./interfaces";

export interface IWithEmailTemplatesState {
  entities: {
    emailTemplates: {
      data: IEntityCollectionState<IEmailTemplate>;
      preview: {
        isError: boolean;
        isLoading: boolean;
        data: { text: string; html: string };
      };
    };
  };
}

export function selectEmailTemplates(state: IWithEmailTemplatesState): IEntityCollectionState<IEmailTemplate> {
  return state.entities.emailTemplates.data;
}

export function selectEmailTemplateById(state: IWithEmailTemplatesState, id: string): IEmailTemplate {
  return selectEmailTemplates(state)[id];
}
export function selectEmailTemplatesList(state: IWithEmailTemplatesState): IEmailTemplate[] {
  return Object.values(selectEmailTemplates(state)).sort((a, b) => dateSort(a.createdAt, b.createdAt));
}

export function selectIsPreviewLoading(state: IWithEmailTemplatesState): boolean {
  return state.entities.emailTemplates.preview.isLoading;
}

export function selectIsPreviewError(state: IWithEmailTemplatesState): boolean {
  return state.entities.emailTemplates.preview.isError;
}

export function selectEmailPreviewData(state: IWithEmailTemplatesState): { text: string; html: string } {
  return state.entities.emailTemplates.preview.data;
}
